import api from "@/lib/api";
import { toast } from "sonner";

const endedClasses = new Set();
const meetWindows = new Map(); // classId -> window handle (reuse, never duplicate)

/* Opens the class's Google Meet — REUSING the already-open Meet tab when there
 * is one (no duplicate join screens). `window.open` without "noopener" keeps a
 * cross-origin handle whose `.closed` we can poll for the auto-end flow. */
export function openMeetTracked(url, onClosed, key = "") {
  if (key) {
    const existing = meetWindows.get(key);
    if (existing && !existing.closed) {
      existing.focus();
      return existing;
    }
  }
  const w = window.open(url, key ? `ts-meet-${key}` : "_blank");
  if (!w) {
    toast.error("Popup blocked — allow popups for this site to open Google Meet");
    return null;
  }
  if (key) meetWindows.set(key, w);
  if (onClosed) {
    const t = setInterval(() => {
      if (w.closed) { clearInterval(t); onClosed(); }
    }, 1500);
  }
  return w;
}

/* Teacher's Meet tab closed → the class is over for EVERYONE, immediately.
 * Students still sitting in the Meet call must NOT keep the class alive —
 * completing the class clears the shared board/quizzes on every student tab.
 * (Duplicate teacher tabs can't happen: openMeetTracked reuses one named
 * window per class.) */
export async function autoEndClass(classId, { onDone } = {}) {
  if (endedClasses.has(classId)) return;
  endedClasses.add(classId);
  try {
    await api.post(`/classes/${classId}/complete`);
  } catch {
    endedClasses.delete(classId);
    return;
  }
  toast.success("Google Meet closed — class ended for everyone");
  onDone?.();
}
